import { Injectable } from '@angular/core';
import { ComponentStore } from '@ngrx/component-store';
import { Store } from '@ngrx/store';
import { of, switchMap } from 'rxjs';

import {
    getLocationsTypeCrop,
    getLocationsTypeDoor,
    getLocationsTypeGeneric,
    getLocationsTypeGreenhouse,
    getLocationsTypePackage,
    getLocationsTypePackhouse,
} from 'app/state/locations/locations.selectors';

import { Activity } from '../activity-selector/models';
import { LocationType } from '../location-selector/models';

export interface LocationSelectorState {
    activity: Activity | undefined;
}

const initialState: LocationSelectorState = {
    activity: undefined,
};

@Injectable()
export class LocationSelectorStore extends ComponentStore<LocationSelectorState> {
    constructor(private store: Store) {
        super(initialState);
    }

    locationList$ = this.state$.pipe(
        switchMap(({ activity }) => {
            if (!activity) return of([]);
            const locationType = activity?.locationType;
            return this.getLocationListByLocationType(locationType);
        }),
    );

    getLocationListByLocationType(locationType: LocationType | null) {
        switch (locationType) {
            case LocationType.Greenhouse:
                return this.store.select(getLocationsTypeGreenhouse);
            case LocationType.Generic:
                return this.store.select(getLocationsTypeGeneric);
            case LocationType.Packhouse:
                return this.store.select(getLocationsTypePackhouse);
            case LocationType.Package:
                return this.store.select(getLocationsTypePackage);
            case LocationType.Crop:
                return this.store.select(getLocationsTypeCrop);
            case LocationType.Door:
                return this.store.select(getLocationsTypeDoor);
            default:
                return of([]);
        }
    }

    updateActivityAndLocationList = this.updater(
        (
            state,
            {
                activity,
            }: {
                activity: Activity | undefined;
            },
        ) => {
            if (state.activity?.locationType === activity?.locationType) return state;
            return { ...state, activity };
        },
    );
}
